import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { WhyTokotetaSection } from '../components/WhyTokotetaSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { NewCTABanner } from '../components/NewCTABanner';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-text-main selection:bg-primary/20" data-id="element-335">
      <Header data-id="element-336" />
      <main data-id="element-337">
        <HeroSection data-id="element-338" />
        <ComparisonSection data-id="element-339" />
        <WhyTokotetaSection data-id="element-340" />
        <HowItWorksSection data-id="element-341" />
        <TestimonialsSection data-id="element-342" />
        <NewCTABanner data-id="element-343" />
      </main>
      <Footer data-id="element-344" />
    </div>;
}